import { Component, inject } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Title } from '@angular/platform-browser';
import { Subscription, filter } from 'rxjs';
import { NavigationStart, ResolveEnd, ResolveStart, Router, RouterEvent } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  private titleService = inject(Title);
  private router: Router = inject(Router);

  public isResolverLoading: boolean = false;
  public pageTitleText: string;

  private subscriptions: Subscription[] = [];

  constructor() {
    console.log(`${environment.tenant.name} ${environment.tenant.productName} ${environment.version.name}`);

    this.pageTitleText = this.getPageTitleText();
    this.initResolverLoadingSpinnerSubscription();
  }

  private getPageTitleText() {
    return `${environment.tenant.name} ${environment.tenant.productName}`;
  }

  initResolverLoadingSpinnerSubscription(): void {
    // when resolvers are processing, user will see a white screen. use this to display a loading spinner while the user is waiting
    this.subscriptions.push(
      this.router.events.subscribe((event) => {
        const routerEvent = event as RouterEvent;
        if (routerEvent instanceof ResolveStart) {
          this.isResolverLoading = true;
          this.titleService.setTitle('Loading...');
        } else if (routerEvent instanceof ResolveEnd) {
          this.isResolverLoading = false;
          this.titleService.setTitle(this.pageTitleText);
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription?.unsubscribe();
    });
  }
}
